import { Form, Input } from "antd";
import { useLocation } from "wouter";
import { useState } from "react";
import Button from "../../Atoms/Button/Button";
import FormBox from "../../Atoms/FormBox/FormBox";
import FormTitle from "../../Atoms/FormTitle/FormTitle";
import InputFormContainer from "../../Atoms/InputFormContainer/InputFormContainer";
import { useModal } from "../../../customHooks/useModal";
import Modal from "../Modal/Modal";
import iconSuccess from "../../../assets/iconProfileCreate.svg";
import "./AccessAndSegurityForm.scss";

const AccessAndSegurityForm = () => {
  const [form] = Form.useForm();
  const [, setLocation] = useLocation();
  const [isOpenModal, openModal, closeModal] = useModal(false);
  const [disabledInput, setDisabledInput] = useState(false);

  const sendForm = (e) => {
    console.log(e); // Aqui el objeto con los valores del formulario
    openModal(true); // Si se envia el formulario correctamente, se muestra el modal
  };

  const clearForm = () => {
    form.resetFields();
    closeModal();
  };

  const goToDashboard = () => {
    closeModal();
    setLocation("/dashboard");
  };

  return (
    <>
      <div className={`buttons-container mt-30`}>
        <button
          onClick={() => setDisabledInput(false)}
          disabled={!disabledInput}
          className="button s-large m-auto grayColor outline"
        >
          Cancelar Edición
        </button>
        <button
          onClick={() => setDisabledInput(true)}
          disabled={disabledInput}
          className="button s-large m-auto grayColor"
        >
          Editar información
        </button>
      </div>
      <Form onFinish={sendForm} form={form}>
        <FormBox>
          <FormTitle text="Datos y seguridad" />
          <InputFormContainer
            spanTwo
            label="Email personal: "
            indentificador="personalEmail"
          >
            <Form.Item
              name="personalEmail"
              rules={[
                {
                  required: true,
                  message: "Por favor ingresa email personal:",
                },
              ]}
            >
              <Input
                size="large"
                placeholder="login@gmail.com"
                disabled={!disabledInput}
              />
            </Form.Item>
          </InputFormContainer>

          <InputFormContainer spanTwo label="Movil: " indentificador="phone">
            <Form.Item
              name="phone"
              rules={[{ required: true, message: "Por favor ingresa movil:" }]}
            >
              <Input
                size="large"
                placeholder="04125458574"
                disabled={!disabledInput}
              />
            </Form.Item>
          </InputFormContainer>

          <FormTitle text="Contraseña" />

          <InputFormContainer
            spanTwo
            label="Verificar contraseña: "
            indentificador="password"
          >
            <Form.Item
              name="password"
              rules={[{ required: true, message: "Ingrese su contraseña!" }]}
            >
              <Input.Password  placeholder="******" size="large" disabled={!disabledInput} />
            </Form.Item>
          </InputFormContainer>

          <InputFormContainer
            label="Nueva contraseña: "
            indentificador="newPassword"
          >
            <Form.Item
              name="newPassword"
              placeholder="******"
              rules={[
                {
                  required: true,
                  whitespace: true,
                  message: "Ingrese su nueva contraseña!",
                },
                {
                  validator: (_, value) =>
                    /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).*$/.test(value)
                      ? Promise.resolve()
                      : Promise.reject("Debe cumplir el formato especificado"),
                },
              ]}
            >
              <Input.Password size="large" disabled={!disabledInput} />
            </Form.Item>
          </InputFormContainer>

          <InputFormContainer
            label="Confirmar contraseña:"
            indentificador="repeatNewPassword"
          >
            <Form.Item
              name="repeatNewPassword"
              placeholder="******"
              rules={[
                {
                  required: true,
                  whitespace: true,
                  message: "Confirme su nueva contraseña!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (
                      !value ||
                      !getFieldValue("newPassword") ||
                      getFieldValue("newPassword").trim() === value.trim()
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject("Las contraseñas no coinciden");
                  },
                }),
              ]}
            >
              <Input.Password size="large" disabled={!disabledInput} />
            </Form.Item>
          </InputFormContainer>

          <div className="form-segurity-rules m-cols-2">
            <ul className="form-segurity-rules_list">
              <div>
                <li>Un carácter en minúscula ejm: (abcde)</li>
                <li>Un carácter en mayúscula ejm: (ABCDE)</li>
                <li>Un número ejm: (12345)</li>
              </div>
              <div>
                <li>Un carácter especial ejm: #$%&/*-?</li>
                <li>8 caracteres como mínimo</li>
                <li>50 caracteres máximo</li>
              </div>
            </ul>
          </div>

          <div className={`buttons-container mt-30 m-cols-2`}>
            <button
              disabled={!disabledInput}
              className="button s-large m-auto primary"
            >
              Actualizar información
            </button>
          </div>
        </FormBox>
      </Form>

      <Modal
        isOpenModal={isOpenModal}
        iconModal={iconSuccess}
        titleModal="Genial"
        closeModal={() => closeModal()}
        subTitleModal="Se ha actualizado / creado tu información de seguridad correctamente. Un correo llegará a tu bandeja, debes confirmarlo para continuar el proceso."
      >
        <div className="buttons-container center mt-20">
          <Button
            content="Ir al dashboard"
            type="primary"
            customClass="s-large m-auto"
            clickHandler={() => goToDashboard()}
          />
          <Button
            content="Cerrar"
            type="primary outline"
            customClass="s-large m-auto"
            clickHandler={clearForm}
          />
        </div>
      </Modal>
    </>
  );
};

export default AccessAndSegurityForm;
